/**
 * Palette des 3 rôles REUT (validée via la skill dataviz — grey/blue/gold, contraste et
 * séparation CVD passés) — source unique partagée entre le donut et les étiquettes qui s'y
 * réfèrent (cartes de synthèse de l'étape Bilan), pour qu'elles restent visuellement reliées.
 */
export const ROLE_COLORS = {
  gisement: '#2f5aa8',
  besoin: '#b8863f',
  neutre: '#c7c6bf',
};

export const ROLE_LABELS = {
  gisement: 'Gisement d\'eau grise',
  besoin: 'Débouché valorisable',
  neutre: 'Hors périmètre REUT',
};
